// extracted by mini-css-extract-plugin
module.exports = {"Frame":"Frame_Frame__AbSJ-","Open":"Frame_Open__3ukn0"};